import React from "react";
import HomeBanner from "../components/home/home-banner";
import HappyCustomers from "../components/home/happy-customers";
import AboutUs from "../components/home/about-us";
import ServiceBanner from "../components/home/service-banner";
import WhatGelDo from "../components/home/what-gel-do";

const Home = () => {
  return (
    <>
        <HomeBanner />
        <HappyCustomers />
        <AboutUs />
        <ServiceBanner />
        <WhatGelDo />
    </>
  );
};


export default Home;
